var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "256", height: "256", viewBox: "0 0 256 256" }, props),
    React.createElement(
      "g",
      { transform: "matrix(2.81 0 0 2.81 1.407 1.407)", strokeWidth: "0", strokeMiterlimit: "10", fill: "#cc492e" },
      React.createElement("path", { d: "M25.871 34.51h-3.406v11.803h3.406c3.254 0 5.901-2.647 5.901-5.901s-2.647-5.902-5.901-5.902z" }),
      React.createElement("path", { d: "M0 9.343v71.112l53.238 8.648V.907L0 9.343zm25.871 40.97h-3.406v8.646h-4V30.51h7.406c5.459 0 9.901 4.442 9.901 9.901s-4.442 9.902-9.901 9.902zM13.806 0h-27.612" }),
      React.createElement("rect", { x: "51.24", y: "53.3", rx: "0", ry: "0", width: "27.61", height: "4" }),
      React.createElement("path", { d: "M13.806 0h-27.612" }),
      React.createElement("rect", { x: "51.24", y: "62.47", rx: "0", ry: "0", width: "27.61", height: "4" }),
      React.createElement("path", { d: "M90 76.595H49.238V10.881H90v65.714zm-36.762-4H86V14.881H53.238v57.714z" }),
      React.createElement("path", { d: "M61.135 35.92V23.86c-4.101 0-7.719 2.051-9.897 5.18V42.8c2.179 3.128 5.796 5.18 9.897 5.18 6.661 0 12.06-5.399 12.06-12.06h-12.06z" }),
      React.createElement("path", { d: "M64.217 32.746h11.072c-.497-5.869-5.191-10.532-11.072-10.985v10.985z" })
    )
  );
});